module.exports = "<span>\r\n  <span id=\"flag-text\">{{flag.name}}</span>\r\n  <span class=\"align-right\">\r\n      <mat-icon id=\"delete-button\" class=\"interactive\" aria-label=\"Delete button\" (click)=\"deleteFlag()\">delete</mat-icon>\r\n  </span>\r\n</span>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Repos/seeya/src/app/generator/flag/flag.component.html
// module id = ../../../../../src/app/generator/flag/flag.component.html
// module chunks = main